import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation } from '@tanstack/react-query';

import { routeService } from '../../../../application/RouteService';
import { Route } from '../../../../domain/route/Route';
import { RouteActionType } from '../context/actions';
import { useRouteContext } from '../context/context';

interface UseDuplicateRouteProps {
  label: string;
  execution_date: Date;
  route_id: string;
}

type UseDuplicateRouteResponseProps = ServiceResponse<
  ({ label, execution_date, route_id }: UseDuplicateRouteProps) => void,
  void
>;

// Hooks act as 'Adapter' layer.
export const useDuplicateRoute = (): UseDuplicateRouteResponseProps => {
  const { routeDispatch } = useRouteContext();

  const { isLoading, isSuccess, isError, mutate } = useMutation<Route, unknown, UseDuplicateRouteProps>(
    ({ label, execution_date, route_id }: UseDuplicateRouteProps): Promise<Route> => {
      return routeService.duplicateRoute({
        label,
        execution_date: execution_date,
        route_id,
      });
    },
    {
      onSuccess: (route) => {
        routeDispatch({ type: RouteActionType.FETCH_ROUTE_SUCCESS, payload: route });
      },
    }
  );

  const createRoute = ({ label, execution_date: executionDate, route_id }: UseDuplicateRouteProps) => {
    mutate({
      label,
      execution_date: executionDate,
      route_id,
    });
  };

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: createRoute,
  };
};
